<template>
  <div>
    <div class="pt-48 pb-130p flex justify-center xl:justify-between max-w-content px-6 xl:px-32 sm:m-auto min-h-screen">
      <div class="text-left">
        <p class="text-neutral/500 text-32 sm:text-100 font-bold">ERROR</p>
        <p class="text-navy text-100 sm:text-180 lg:text-218 font-bold leading-none">404</p>
        <p class="text-neutral/500 text-18">Ooops...... we couldn’t find the page you are looking for.</p>
        <p class="text-neutral/500 text-18">But don’t worry, we will fix it soon.</p>

        <button  @click="$router.go(-2)" class="back-button mt-60p hover:bg-primary1 text-black font-normal text-18 p-3 rounded-full cursor-pointer bg-white border hover:border-transparent border-primary1 px-12">
          Back
        </button>
      </div>

      <img class="h-480p hidden xl:block" src="@/assets/image404.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>

<style scoped>
.back-button {
  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(4, 23, 41, .18);
}

.back-button:active {
  transform: translateY(0);
}

.back-button:focus-visible {
  outline: 2px solid #E8B300;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .back-button {
    transition: none;
  }

  .back-button:hover {
    transform: none;
  }
}
</style>
